import { render, staticRenderFns } from "./WidgetBalance.vue?vue&type=template&id=f0eaaae6&scoped=true&"
import script from "./WidgetBalance.vue?vue&type=script&lang=ts&"
export * from "./WidgetBalance.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetBalance.vue?vue&type=style&index=0&id=f0eaaae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eaaae6",
  null
  
)

export default component.exports